import React from "react";
import {
    CURRENCY_EURO,
    isDefined,
    parseAmount, titleize,
} from "../../utils/utils";
import I18n from 'i18n.js.erb'
import { SaleItemFormLabel } from "./SaleForm";

const CouriersSelect = ({
    couriers,
    category,
    saleItem,
    selectedShipmentMethod,
    handleUpdateShipmentMethod,
    safeShipmentMethod,
    disabled
}) => {

    // Funzione che raggruppa i corrieri sulla base della loro categoria (servizio standard / economy / express / ecc.)
    const groupedCouriers = couriers.reduce((acc, courier) => {
        const propertyValue = courier['category'];
        if (!acc[propertyValue]) {
            acc[propertyValue] = [];
        }
        acc[propertyValue].push(courier);
        return acc;
    }, {});

    const selectedSafeShipmentMethod = safeShipmentMethod(selectedShipmentMethod, category);



    return (
        <select
            className={`form-control sale-item-form-input mb-1 sale-item-form-select ${selectedSafeShipmentMethod?.id ? '' : 'sale-item-form-placeholder'} ${disabled ? 'opacity-0_3-imp' : ''}`}
            value={selectedSafeShipmentMethod?.id ? selectedSafeShipmentMethod.id : ''}
            id={`${category}_shipment_method_${saleItem.id}`}
            disabled={disabled}
            onChange={(e) => {
                handleUpdateShipmentMethod(category, { id: e.target.value, name: e.target.options[e.target.selectedIndex].label })
            }}
        >
            <option
                value={""}>{I18n.t('js.indexSaleItems.shipmentMethod.selectCouriers')}
            </option>

            {
                Object.keys(groupedCouriers)?.length > 1 ?
                    Object.entries(groupedCouriers).map(([category, couriersByCategory]) => {
                        return <optgroup key={category}
                            label={titleize(I18n.t('js.indexSaleItems.shipmentMethod.services').replace(':services', category))}>
                            {
                                couriersByCategory.map((courier) => {
                                    return <option value={courier.id} label={courier.name} key={courier.id}>
                                        {courier.name}
                                    </option>
                                })
                            }
                        </optgroup>
                    })
                    :
                    couriers.map((courier) => (
                        <option value={courier.id} label={courier.name} key={courier.id}>
                            {courier.name}
                        </option>
                    ))
            }
        </select>
    )
}


const ShipmentMethodForm = ({
    saleItem,
    couriers,
    category,
    handleUpdateSaleItem,
    safeShipmentMethod,
    saleItemToUpdate,
    setSaleItemToUpdate,
    saleItemToParseValue,
    disabled
}) => {

    const safeShipmentMethodByCategory = safeShipmentMethod(saleItemToUpdate?.updatedSaleItem?.id === saleItem.id ? saleItemToUpdate.updatedSaleItem.shipment_method : saleItem.shipment_method, category)


    // Costante che dice se debba essere abilitato o meno un selettore che consente all'utente di impostare i campi
    // per la spedizione nazionale / internazionale
    const enableShipmentMethodInputForm =
        (saleItem.editable) && isDefined(saleItem.shipment_method?.id) &&
        (saleItem.shipment_method.id === 'new_shipment_method_international' || category !== 'international');


    // Funzione che modifica i parametri del metodo di spedizione scelto dall'utente sull'interfaccia grafica per il sale item corrente
    const handleUpdateShipmentMethod = (category, newMethodParams, debounce = false) => {
        const newSelectedShipmentMethod = { ...saleItem.shipment_method };

        let newMethod = { ...newMethodParams };
        const shipmentMethodByCategory = safeShipmentMethod(newSelectedShipmentMethod, category)

        if (isDefined(shipmentMethodByCategory))
            newMethod = { ...shipmentMethodByCategory, ...newMethod };

        newSelectedShipmentMethod[category] = [newMethod];
        if (!isDefined(newMethod?.id) && !isDefined(newMethod?.amount))
            delete newSelectedShipmentMethod[category];

        if (debounce)
            setSaleItemToUpdate({ oldSaleItem: { ...saleItem }, updatedSaleItem: { ...saleItemToParseValue, shipment_method: newSelectedShipmentMethod } })
        else
            handleUpdateSaleItem({ ...saleItem, shipment_method: newSelectedShipmentMethod });
    }



    return (
        <React.Fragment>
            <div className={`
                col-12 col-lg-6 col-xl-4 border-bottom-aiG-light-gray-imp 
                border-right-lg-aiG-light-gray-imp border-right-xl-aiG-light-gray-imp
                ${disabled ? 'cursor-not-allowed' : ''}    
            `}>
                <div className="d-block pl-2">
                    <SaleItemFormLabel
                        title={I18n.t(`js.indexSaleItems.shipmentMethod.${category}Shipment`)}
                        message={I18n.t(`js.indexSaleItems.shipmentMethod.${category}Description`)}
                        id={`${category}_shipment_method_${saleItem.id}_label`}
                        disabled={disabled}
                    />
                    {enableShipmentMethodInputForm ?
                        <CouriersSelect
                            couriers={couriers}
                            category={category}
                            saleItem={saleItem}
                            selectedShipmentMethod={saleItem.shipment_method}
                            handleUpdateShipmentMethod={handleUpdateShipmentMethod}
                            safeShipmentMethod={safeShipmentMethod}
                            disabled={disabled}
                        />
                        :
                        <p className={`mb-1 ${disabled ? 'opacity-0_3-imp' : ''}`}>
                            {isDefined(safeShipmentMethodByCategory?.name) ?
                                safeShipmentMethodByCategory.name
                                :
                                I18n.t('js.indexSaleItems.listingForm.notSet')}
                        </p>
                    }
                </div>
            </div>


            <div className={`col-12 col-lg-6 col-xl-4 border-bottom-aiG-light-gray-imp ${disabled ? 'cursor-not-allowed' : ''}`}>
                <div className="d-block pl-2">
                    <SaleItemFormLabel
                        title={I18n.t(`js.indexSaleItems.shipmentMethod.amount`)}
                        message={I18n.t(`js.indexSaleItems.shipmentMethod.${category}AmountDescription`)}
                        id={`${category}_shipment_method_amount_${saleItem.id}_label`}
                        disabled={disabled}
                    />
                    {enableShipmentMethodInputForm ?
                        <input
                            type="number"
                            min="0"
                            step={"0.5"}
                            disabled={disabled}
                            value={isDefined(safeShipmentMethodByCategory?.amount) ? safeShipmentMethodByCategory.amount : ''}
                            className={`form-control sale-item-form-input border-left-radius-3px-imp w-100 mb-1 ${disabled ? 'opacity-0_3-imp' : ''}`}
                            placeholder={I18n.t('js.indexSaleItems.placeholders.typeAValue')}
                            onChange={(e) => handleUpdateShipmentMethod(category, { amount: isDefined(e.target.value) ? parseFloat(e.target.value) : null }, true)}
                            id={`${category}_shipment_method_amount_${saleItem.id}`}
                        />
                        :
                        <p className={`mb-1 ${disabled ? 'opacity-0_3-imp' : ''}`}>
                            {isDefined(safeShipmentMethodByCategory?.amount) ?
                                `${parseAmount(safeShipmentMethodByCategory.amount, 2, true)}${CURRENCY_EURO}`
                                :
                                I18n.t('js.indexSaleItems.listingForm.notSet')}
                        </p>
                    }
                </div>
            </div>
        </React.Fragment>
    )
}

export default ShipmentMethodForm
